import { api } from '@/lib/api/client'
import type { CreateWorkspaceInput, Workspace } from '@/features/workspaces/types/workspace'

/** `POST /workspaces` creates a workspace inside an organization. */
export async function createWorkspace(input: CreateWorkspaceInput): Promise<Workspace> {
  const { data } = await api.post<{ data: Workspace }>('/workspaces', {
    organization_id: input.organizationId,
    name: input.name,
  })

  return data.data
}
